import { render, staticRenderFns } from "./InformacoesGerais.vue?vue&type=template&id=5241c98d&scoped=true"
import script from "./InformacoesGerais.vue?vue&type=script&lang=js"
export * from "./InformacoesGerais.vue?vue&type=script&lang=js"
import style0 from "./InformacoesGerais.vue?vue&type=style&index=0&id=5241c98d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5241c98d",
  null
  
)

export default component.exports